var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainHeaderGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 696,
    height: 520,
    viewBox: "0 0 696 520",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-.3%",
    y: "-.5%",
    width: "101.2%",
    height: "102.1%",
    filterUnits: "objectBoundingBox",
    id: "3qcgrwxosa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.129411765 0 0 0 0 0.149019608 0 0 0 0 0.168627451 0 0 0 1 0",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-.1%",
    y: "-2.3%",
    width: "100.2%",
    height: "103.1%",
    filterUnits: "objectBoundingBox",
    id: "fugr9lektc"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.847058824 0 0 0 0 0.862745098 0 0 0 0 0.88627451 0 0 0 1 0",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 0h640a4 4 0 0 1 4 4v369a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    id: "f1wpqx3oob"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 288h598v60a4 4 0 0 1-4 4H29a4 4 0 0 1-4-4v-60z",
    id: "dgqkepnm3d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "8jpxthovue"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F94",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5801E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h696v520H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43 51)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#3qcgrwxosa)",
    xlinkHref: "#f1wpqx3oob"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#21262B",
    strokeWidth: 2,
    d: "M644 1a2.99 2.99 0 0 1 2.121.879A2.99 2.99 0 0 1 647 4v369a2.99 2.99 0 0 1-.879 2.121A2.99 2.99 0 0 1 644 376H4a2.99 2.99 0 0 1-2.121-.879A2.99 2.99 0 0 1 1 373V4c0-.828.336-1.578.879-2.121A2.99 2.99 0 0 1 4 1z",
    strokeLinejoin: "square",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#21262B",
    d: "M43 131h648v1H43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 156h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445 166-5 5-5-5",
    stroke: "#21262B",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-Medium, Unbounded",
    fontSize: 14,
    fontWeight: 400,
    fill: "#21262B",
    transform: "translate(263 156)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 52,
    y: 15
  }, "Professional")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-Regular, Unbounded",
    fontSize: 14,
    fill: "#595C60",
    transform: "translate(263 156)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.404,
    y: 15
  }, "Tone:")), /*#__PURE__*/React.createElement("path", {
    d: "M203 156h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220 166-5 5-5-5",
    stroke: "#21262B",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-Medium, Unbounded",
    fontSize: 14,
    fontWeight: 400,
    fill: "#21262B",
    transform: "translate(74 156)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 55,
    y: 15
  }, "Medium")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-Regular, Unbounded",
    fontSize: 14,
    fill: "#595C60",
    transform: "translate(74 156)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.156,
    y: 15
  }, "Level:")), /*#__PURE__*/React.createElement("path", {
    d: "M636 156h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m653 166-5 5-5-5",
    stroke: "#21262B",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-Medium, Unbounded",
    fontSize: 14,
    fontWeight: 400,
    fill: "#21262B",
    transform: "translate(488 156)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 98,
    y: 15
  }, "1000")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-Regular, Unbounded",
    fontSize: 14,
    fill: "#595C60",
    transform: "translate(488 156)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.932,
    y: 15
  }, "Word limit:")), /*#__PURE__*/React.createElement("path", {
    d: "M663 204.5c.966 0 1.841.392 2.475 1.025A3.489 3.489 0 0 1 666.5 208v192c0 .966-.392 1.841-1.025 2.475A3.489 3.489 0 0 1 663 403.5H71a3.489 3.489 0 0 1-2.475-1.025A3.489 3.489 0 0 1 67.5 400V208c0-.966.392-1.841 1.025-2.475A3.489 3.489 0 0 1 71 204.5z",
    stroke: "#D8DCE2",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43 51)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#fugr9lektc)",
    xlinkHref: "#dgqkepnm3d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F3F6FB",
    xlinkHref: "#dgqkepnm3d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(469 351)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#DF761E",
    fill: "url(#8jpxthovue)",
    width: 180,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-Medium, Unbounded",
    fontSize: 14,
    fontWeight: 400,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 55,
    y: 23
  }, "Improve"))), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-Light, Unbounded",
    fontSize: 14,
    fontWeight: 300,
    fill: "#21262B",
    transform: "translate(43 51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    y: 185
  }, "Brief explanation about generative platfo")), /*#__PURE__*/React.createElement("path", {
    fill: "#21262B",
    d: "M422 223h1v20h-1z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Unbounded-SemiBold, Unbounded",
    fontSize: 22,
    fontWeight: 500,
    fill: "#21262B",
    transform: "translate(43 51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 164,
    y: 46
  }, "Improve &amp; ask anything")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67 84)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E54371",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5DB6A",
    cx: 29,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#50E082",
    cx: 51,
    cy: 7,
    r: 7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85 359h24v24H85z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#21262B",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 367v-3h14v3M94 378h6M97 364v14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M157 359h24v24h-24z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159 361)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#21262B",
    strokeLinecap: "square",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13v-2a3 3 0 1 0-3-3",
    stroke: "#21262B",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21262B",
    fillRule: "nonzero",
    cx: 10,
    cy: 16,
    r: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229 359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.01c-4.096 0-7.985-.364-9.47 3.445C1.914 7.03 2.004 9.072 2.004 12c0 2.567-.083 4.98.524 6.542 1.482 3.812 5.403 3.447 9.469 3.447 3.922 0 7.966.408 9.47-3.447.615-1.59.525-3.603.525-6.542 0-3.903.215-6.422-1.679-8.313-1.918-1.916-4.511-1.676-8.318-1.676H12z",
    stroke: "#21262B",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5a1 1 0 1 0 0 2.001A1 1 0 0 0 18 5z",
    fill: "#21262B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#21262B",
    strokeLinecap: "square",
    cx: 12,
    cy: 12,
    r: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301 359h24v24h-24z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#21262B",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323 363v16h-20v-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323 364-10 7-10-7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M559.048 449.75c6.096 3.941 7.554 9.596 4.373 16.214l-.386-.663c-2.811-4.851-5.062-9.505-3.987-15.552zm-44.376 3.626c7.366 3.863 10.434 10.593 8.183 17.668l-1.535-2.076-.467-.64c-3.168-4.376-5.87-8.785-6.18-14.952zm92.871-68.95c.86.401 1.284.464 1.483.71 16.131 19.91 23.616 42.46 20.374 68.097-.825 6.512-3.309 12.611-7.046 18.116-8.058 11.872-22.192 16.923-35.924 12.809-7.108-2.13-13.576-5.286-18.303-11.355.7-3.425 1.608-6.756 2.026-10.148.66-5.351-.478-10.337-4.105-14.531-2.728-3.156-5.992-4.41-8.552-3.182-3.23 1.55-4.312 4.649-3.836 7.728.666 4.307 1.975 8.558 3.425 12.687.94 2.68 2.624 5.097 3.945 7.577-6.513 11.977-20.503 13.053-33.027 2.48.171-1.947.482-4.02.513-6.098.111-7.478-2.116-14.071-8.07-18.907l-.367-.29-.355-.266c-2.091-1.515-4.552-2.458-7.284-1.126-2.358 1.149-3.513 4.352-2.82 8.14 1.1 6.018 4.197 11.096 7.883 15.849 1.284 1.654 2.68 3.222 3.965 4.759-9.372 18.878-32.121 26.358-46.664 12.162-.355 1.494-1.014 2.662-.738 3.534.306.966 1.334 1.885 2.274 2.441 8.866 5.244 18.153 7.384 28.039 3.112 7.163-3.096 13.107-7.844 18.048-13.846l.42-.518a90.712 90.712 0 0 1 2.2-2.628c.11-.128.334-.154.856-.375l.664.309c.815.373 1.752.79 2.646 1.284 14.195 7.848 23.564 6.66 35.693-4.828l2.29 1.773c.258.2.517.403.775.606l.774.613c7.6 6.075 16.228 9.436 25.972 9.753 16.026.524 29.74-8.43 36.308-23.581 3.577-8.247 5.173-16.88 4.956-25.826-.522-21.467-7.133-40.653-21.395-56.92l-.483-.546c-.766-.861-1.52-1.735-2.258-2.62-.1-.12-.074-.349-.24-1.263 3.93.466 7.294 2.009 10.662 3.415l.505.21c3.48 1.434 6.903 3.012 10.64 4.654.722-2.965-.314-4.673-1.934-5.987l-1.63-1.289-.69-.537c-1.271-.974-2.587-1.878-4.02-2.46-6.046-2.456-12.163-4.82-18.416-6.661-4.978-1.465-7.268.669-6.514 5.405a2586.97 2586.97 0 0 0 4.995 30.122c.268 1.571.92 3.078 1.544 5.096 2.796-1.542 2.766-3.484 2.623-5.347l-.276-3.512c-.12-1.52-.244-3.043-.37-4.576l-1.18-14.218z",
    fill: "#21262B"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "JoyLikeSunshineThroughMyWindowpane, Joy Like Sunshine Through My Windowpane",
    fontSize: 40,
    fill: "#21262B",
    transform: "translate(43 51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 108,
    y: 446
  }, "magic happens here")), /*#__PURE__*/React.createElement("path", {
    d: "M28.323 105c.43.234.552.641.733 1.012.7 1.432 1.448 2.842 2.107 4.293 1.407 3.097 3.044 6.069 4.77 8.995.847 1.435 1.604 2.914 2.164 4.486.16.453.318.904.732 1.263.32-.174.638-.314.922-.503 3.752-2.501 7.657-4.749 11.537-7.039 1.79-1.057 3.548-2.17 5.316-3.265.53-.329 1.048-.67 1.67-.819.513-.123.867.11.787.613-.198 1.231-.446 2.455-.66 3.684-1.062 6.145-2.095 12.295-3.187 18.435-.861 4.843-1.792 9.673-2.693 14.509-.051.273-.13.54-.183.812-.093.487-.372.7-.872.661a542.956 542.956 0 0 0-4.768-.358c-2.974-.211-5.946-.444-8.922-.616-6.09-.351-12.187-.621-18.275-1.012-4.841-.311-9.693-.502-14.514-1.091a25.777 25.777 0 0 0-.828-.083c-.398-.034-.628-.257-.7-.637-.074-.408-.152-.819-.186-1.232-.401-4.906-.891-9.806-.945-14.735-.09-8.044-.203-16.087-.305-24.131-.004-.277-.02-.555-.002-.832.027-.397-.154-.891.22-1.158.47-.337.939-.032 1.32.261.548.422 1.1.856 1.57 1.359 4.308 4.609 8.606 9.226 12.889 13.86.744.805 1.398 1.695 2.195 2.671.768-1.086.842-2.294 1.308-3.336.479-1.075.926-2.166 1.384-3.251.458-1.085.914-2.171 1.367-3.259.426-1.023.845-2.049 1.27-3.074.45-1.088.887-2.183 1.363-3.26.474-1.072.758-2.231 1.416-3.223",
    fill: "#FFC390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.823 19.407c-.039-2.13.243-4.231.498-6.34.288-2.375.778-4.696 1.56-6.954.41-1.187.843-2.371 1.602-3.396.52-.7 1.095-1.33 1.878-1.758.79-.432 1.391-.182 1.886.533.398.575.53 1.265.665 1.952.303 1.547.252 3.108.264 4.668.003.607 0 1.215 0 1.834.394.05.38-.286.453-.48a38.247 38.247 0 0 1 2.425-5.313c.698-1.253 1.472-2.455 2.552-3.423.29-.26.569-.513.959-.64.816-.268 1.625.073 1.844.89.142.53.282 1.058.165 1.656-.198 1.016-.173 2.064-.338 3.096-.218 1.367-.424 2.736-.699 4.092-.087.428-.172.848-.075 1.279.218.046.332-.09.41-.242.582-1.129 1.396-2.094 2.233-3.022.628-.697 1.349-1.328 2.233-1.743.591-.28 1.086-.171 1.576.169.655.454.94 1.146 1.007 1.892.102 1.123.123 2.266-.045 3.381-.642 4.302-1.81 8.468-3.435 12.497a49.342 49.342 0 0 1-4.655 8.844c-.506.763-.748 1.51-.672 2.429.492 5.936.134 11.888.326 17.83.103 3.163.025 6.339.266 9.491.248 3.212-.931 7.4-3.652 8.832-2.72 1.432-20.696-.243-20.837-2.057-.54-6.894-.084-13.798-.198-20.696-.007-.434.047-.859.115-1.29.1-.636.098-1.287.136-1.87-.29-.248-.486-.095-.662-.012-1.272.6-2.656.711-4.012.948-.21.037-.432.024-.646.008-3.4-.242-6.467-1.269-9.116-3.545-1.615-1.387-2.811-3.037-3.803-4.879-1.049-1.951-1.14-4.06-.953-6.206.022-.255.122-.505.205-.75.725-2.137 2.198-2.65 4.048-2.235.932.21 1.778.65 2.49 1.331.842.808 1.701 1.6 2.575 2.375a21.999 21.999 0 0 0 3.585 2.555c1.07.619 2.269.824 3.473.924 1.024.086 1.962-.274 2.77-.902 1.656-1.285 2.555-3.016 2.851-5.077.102-.71-.068-1.387-.367-2.022-.654-1.394-1.698-2.388-3.124-2.965-.795-.322-1.609-.268-2.415-.067-.933.233-1.769.688-2.559 1.228-.931.635-1.927 1.152-2.942 1.637-2.44 1.165-5.396-.463-6.212-2.458-.435-1.057-.374-2.122-.112-3.188.263-1.074.809-2.025 1.538-2.832 1.336-1.478 2.753-2.846 4.523-3.85 2.848-1.616 5.807-2.078 8.982-1.363 2.547.572 4.728 1.864 6.755 3.443.822.64 1.476 1.457 1.987 2.382.14.253.21.569.695.823 0-.584.006-1.014-.001-1.444z",
    fill: "#FEB3B2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.467 442.677c.319-.16.553-.397.614-.755.121-.708.357-1.393.326-2.13-.058-1.438.039-2.873-.198-4.313-.162-.986-.064-2.015-.078-3.024-.03-2.068-.326-4.109-.674-6.142-.452-2.645-.883-5.294-1.41-7.925-.392-1.958-.267-3.922-.271-5.888 0-.378.076-.766.18-1.132.684-2.418 1.691-4.705 2.93-6.89.689-1.213 1.39-2.427 2.192-3.566 2.816-4 6.3-7.296 10.698-9.55 2.593-1.328 5.35-2.217 8.21-2.827 1.144-.243 2.314-.205 3.448-.48.366-.09.776-.05 1.16-.014 3.645.356 7.174 1.126 10.4 2.932 3.853 2.157 7.134 4.946 9.664 8.576.993 1.427 1.935 2.89 2.716 4.43 1.176 2.322 2.03 4.751 2.394 7.363.241 1.73.266 3.448.202 5.172-.07 1.876-.54 3.695-1.085 5.49-1.26 4.15-3.337 7.849-6.129 11.19a29.746 29.746 0 0 1-4.356 4.218c-1.298 1.03-2.816 1.687-4.36 2.274-1.811.69-3.701 1.124-5.559 1.663-.697.203-1.4.387-2.086.617-2.663.891-5.317 1.803-7.978 2.698-1.246.418-2.422.984-3.573 1.606-1.473.798-2.638 1.943-3.634 3.265-.26.347-.49.716-.734 1.074-1.103-1.41-2.206-2.816-3.934-3.55-.334-.142-.327-.428-.187-.73.528-1.134 1.13-2.243 1.558-3.412a597.07 597.07 0 0 1 5.037-13.218c.46-1.172.448-1.191 1.656-.761 1.83.652 3.682 1.22 5.64 1.334 3.112.182 5.978-.47 8.444-2.465 1.344-1.088 2.275-2.485 3.055-3.993.691-1.337 1.224-2.737 1.328-4.243.284-4.123-1.228-7.553-4.357-10.227-1.974-1.686-4.31-2.428-6.911-1.679-2.646.761-4.628 2.37-5.81 4.872-.123.26-.21.54-.272.821-.34 1.574-.231 3.073.881 4.352 1.029 1.184 2.37 1.805 3.919 1.996.589.071 1.168.003 1.695-.29.696-.388 1.059-.975 1.006-1.778-.053-.81-.558-1.255-1.414-1.28-.387-.01-.782.007-1.161-.057-1.537-.263-2.087-1.388-1.37-2.77.11-.212.248-.414.4-.6a6.45 6.45 0 0 1 1.75-1.503c1.582-.934 3.151-.882 4.654.134 2.477 1.675 4.595 5.732 3.204 9.457a12.129 12.129 0 0 1-1.828 3.263 6.25 6.25 0 0 1-1.867 1.587c-1.757.992-3.649 1.237-5.627 1.013-1.456-.166-2.837-.62-4.207-1.112-.684-.246-1.364-.493-2.09-.607-.988-.154-1.815.124-2.512.826-.56.563-.887 1.25-1.162 1.978-1.523 4.001-3.17 7.957-4.587 11.997-.574 1.632-1.244 3.234-1.5 4.962-.064.428-.298.504-.738.23-1.78-1.104-3.686-1.915-5.702-2.479",
    fill: "#FFBC4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.467 442.677c2.016.564 3.923 1.375 5.702 2.479.44.274.674.198.738-.23.256-1.728.926-3.33 1.5-4.962 1.418-4.04 3.064-7.996 4.587-11.997.275-.727.603-1.415 1.162-1.978.697-.702 1.524-.98 2.512-.826.726.114 1.406.36 2.09.607 1.37.493 2.75.946 4.207 1.112 1.978.224 3.87-.02 5.627-1.013a6.25 6.25 0 0 0 1.867-1.587 12.129 12.129 0 0 0 1.828-3.263c1.391-3.725-.727-7.782-3.204-9.457-1.503-1.016-3.072-1.068-4.654-.134a6.45 6.45 0 0 0-1.75 1.503c-.152.186-.29.388-.4.6-.717 1.382-.167 2.507 1.37 2.77.38.064.774.047 1.161.057.856.025 1.361.47 1.414 1.28.053.803-.31 1.39-1.006 1.778-.527.293-1.106.361-1.695.29-1.55-.19-2.89-.812-3.919-1.996-1.112-1.28-1.222-2.778-.88-4.352.06-.28.148-.562.27-.821 1.183-2.503 3.165-4.11 5.81-4.872 2.602-.75 4.938-.007 6.912 1.68 3.129 2.673 4.64 6.103 4.357 10.226-.104 1.506-.637 2.906-1.328 4.243-.78 1.508-1.711 2.905-3.055 3.993-2.466 1.995-5.332 2.647-8.444 2.465-1.958-.113-3.81-.682-5.64-1.334-1.208-.43-1.196-.41-1.656.761a597.07 597.07 0 0 0-5.037 13.218c-.427 1.17-1.03 2.278-1.558 3.413-.14.3-.147.587.187.728 1.728.735 2.83 2.141 3.934 3.55.183.394.352.793.548 1.178.45.877.616 1.803.592 2.783-.05 2.023-.951 3.477-2.843 4.29-.358.153-.709.25-.706.766.008 1.325-.803 2.097-1.92 2.633-.173.083-.351.173-.537.217-.39.094-.562.317-.55.718.053 1.595-1.407 2.781-3.065 2.805-1.618.024-3.189-.147-4.688-.78-2.6-1.1-4.994-2.542-7.21-4.273a10.6 10.6 0 0 1-2.021-2.06c-.64-.87-1.061-1.816-1.076-2.924-.017-1.413.57-2.501 1.712-3.312.196-.138.411-.257.63-.354.402-.18.612-.423.483-.898-.114-.423-.035-.855.04-1.285.203-1.161.81-2.037 1.832-2.633.246-.144.504-.267.698-.368.19-.37-.03-.627-.064-.904-.258-2.08.973-3.552 3.108-3.642.674-.03 1.351.071 2.028.112",
    fill: "#21262B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainHeaderGraphic);
export default __webpack_public_path__ + "static/media/main-header-graphic.39e88df5c53d1779ea55d6941efe4355.svg";
export { ForwardRef as ReactComponent };